import React, { useEffect, useMemo, useState } from 'react';
import { Spin, Switch } from 'antd';
import * as styles from './position-insights.module.scss';
import { KEY_NAME_POSITION_STATUS, POSITION_INSIGHTS_TAB, TA_DETAIL_PATH, TA_TABS, TA_YEARS_OPTIONS } from '../../talent-analytics.constant';
import BarChartCard from '../PositionInsightsBarChartCard/BarChartCard';
import DropdownYears from '../DropdownYears/DropdownYears';
import { talentAnalyticApi } from '../../../../services/talentAnalyticApi';
import PositionStatusPositionInsights from '../PositionStatusPositionInsights/PositionStatusPositionInsights';
import { useHistory, useLocation } from 'react-router-dom';
import ViewReportPositionInsights from '../ViewReportPositionInsights/ViewReportPositionInsights';
// import SPWithoutSuccessor from '../SPWithoutSuccessor/SPWithoutSuccessor';

const PositionInsights = ({ reportType }) => {
  const history = useHistory();
  const [currentTab, setCurrentTab] = useState(reportType || POSITION_INSIGHTS_TAB[0]);
  const [yopFilter, setYopFilter] = useState(TA_YEARS_OPTIONS[0].startEndYear);
  const [selectedYearValue, setSelectedYearValue] = useState(TA_YEARS_OPTIONS[0].value);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    [POSITION_INSIGHTS_TAB[0]]: {},
    [POSITION_INSIGHTS_TAB[1]]: {},
    [POSITION_INSIGHTS_TAB[2]]: {},
  });
  const [showSensitiveOnly, setShowSensitiveOnly] = useState(false);
  const [totalPositionStatus, setTotalPositionStatus] = useState(null);
  const [activeKey, setActiveKey] = useState(KEY_NAME_POSITION_STATUS.POSITION_APPROVED_SP);
  const [yopOptions, setYopOptions] = useState([]);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tabIndex = searchParams.get('tab');
  useEffect(() => {
    if (tabIndex && !isNaN(tabIndex)) {
      setCurrentTab(POSITION_INSIGHTS_TAB[tabIndex]);
    }
  }, [tabIndex]);

  const displayData = useMemo(() => {
    return data[currentTab];
  }, [currentTab, data]);

  const [stackChartData, setStackChartData] = useState({
    [POSITION_INSIGHTS_TAB[0]]: {},
    [POSITION_INSIGHTS_TAB[1]]: {},
  });
  // const [stackChartData, setStackChartData] = useState({
  //   [POSITION_INSIGHTS_TAB[1]]: {},
  //   [POSITION_INSIGHTS_TAB[2]]: {},
  // });

  const handleOnClickReport = () => {
    history.push(`${window.location.pathname}?report=${currentTab}`);
  };

  const getYearsOfPositionPositionInsights = async () => {
    const payload = {
      filter: {
        start_year: yopFilter.startYear,
        end_year: yopFilter.endYear,
        sensitive_position: showSensitiveOnly,
      },
    };
    setLoading(true);
    try {
      const res = await talentAnalyticApi.fetchYearsOfPositionPositionInsights(payload);
      if (res.status === 200) {
        setData((prev) => ({ ...prev, [POSITION_INSIGHTS_TAB[1]]: res.data.result }));
        // setData((prev) => ({ ...prev, [POSITION_INSIGHTS_TAB[2]]: res.data.result }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getYearsOfPositionOptions = async () => {
    setLoading(true);
    try {
      const res = await talentAnalyticApi.fetchYearsOfPositionOptionsPositionInsights();
      if (res.status === 200) {
        const options = res.data.result.pa_years_options;
        setYopOptions(options);

        if (options.length > 0) {
          setSelectedYearValue(options[0].value);
          setYopFilter(options[0].startEndYear);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentTab !== POSITION_INSIGHTS_TAB[1]) return;
    // if (currentTab !== POSITION_INSIGHTS_TAB[2]) return;
    getYearsOfPositionOptions();
  }, [currentTab]);

  useEffect(() => {
    if (currentTab !== POSITION_INSIGHTS_TAB[1]) return;
    // if (currentTab !== POSITION_INSIGHTS_TAB[2]) return;
    getYearsOfPositionPositionInsights();
  }, [currentTab, yopFilter, showSensitiveOnly]);

  const getTotalPositionStatus = async () => {
    try {
      setLoading(true);
      const res = await talentAnalyticApi.fetchTotalPositionStatusInPositionInsights();
      if (res.status === 200) {
        setTotalPositionStatus(res.data.result.total_positions);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (currentTab !== POSITION_INSIGHTS_TAB[1]) return;
    if (currentTab !== POSITION_INSIGHTS_TAB[0]) return;
    getTotalPositionStatus();
  }, [currentTab]);

  const getTotalPosition = useMemo(() => {
    let totalPosition = null;

    switch (currentTab) {
      // case POSITION_INSIGHTS_TAB[0]:
      //   totalPosition = null;
      //   break;
      // case POSITION_INSIGHTS_TAB[1]:
      //   totalPosition = totalPositionStatus;
      //   break;
      // case POSITION_INSIGHTS_TAB[2]:
      //   totalPosition = displayData?.total_positions;
      //   break;
      case POSITION_INSIGHTS_TAB[0]:
        totalPosition = totalPositionStatus;
        break;
      case POSITION_INSIGHTS_TAB[1]:
        totalPosition = displayData?.total_positions;
        break;
      default:
        break;
    }
    return totalPosition;
  }, [currentTab, totalPositionStatus, data[POSITION_INSIGHTS_TAB[1]]]);
  // }, [currentTab, totalPositionStatus, data[POSITION_INSIGHTS_TAB[2]]]);

  const onChangeTab = (tab, tabNumber) => {
    setCurrentTab(tab);
    setStackChartData((pre) => ({
      ...pre,
      [tab]: {},
    }));
    history.push(`${TA_DETAIL_PATH}/${TA_TABS[1].path}?tab=${tabNumber}`);
  };

  return (
    <>
      {!reportType ? (
        <div className={styles.wrapper}>
          <Spin spinning={loading}>
            <div className={styles.contents}>
              <div className={styles.tabs}>
                {POSITION_INSIGHTS_TAB.map((tab, tabIndex) => (
                  <div key={tab} className={`${styles.tab} ${currentTab === tab ? styles.active : ''}`} onClick={() => onChangeTab(tab, tabIndex)}>
                    {tab}
                  </div>
                ))}
              </div>
              {currentTab === POSITION_INSIGHTS_TAB[1] && (
                // {currentTab === POSITION_INSIGHTS_TAB[2] && (
                <>
                  <div className={styles.yisg}>
                    <div className={styles.filters}>
                      <div>Years of Position</div>
                      <div className="ml-2">
                        <DropdownYears
                          placeholder="Select"
                          options={yopOptions}
                          onChange={(value) => {
                            setSelectedYearValue(value);
                            const selectedOption = yopOptions.find((option) => option.value === value);
                            setYopFilter(selectedOption.startEndYear);
                          }}
                          value={selectedYearValue}
                        />
                      </div>
                      <div className={styles.sensitiveToggle}>
                        Show Sensitive Positions Only
                        <Switch className={`ml-2`} checked={showSensitiveOnly} onChange={(checked) => setShowSensitiveOnly(checked)} />
                      </div>
                    </div>
                    <div className={styles.totalPositions}>
                      <div>Total Positions</div>
                      <span>{displayData?.total_positions}</span>
                    </div>
                  </div>

                  <div className={styles.charts}>
                    {currentTab === POSITION_INSIGHTS_TAB[1] && (
                      // {currentTab === POSITION_INSIGHTS_TAB[2] && (
                      <BarChartCard
                        data={displayData}
                        showSensitiveOnly={showSensitiveOnly}
                        onViewReport={handleOnClickReport}
                        setStackChartData={setStackChartData}
                      />
                    )}
                  </div>
                </>
              )}
              {currentTab === POSITION_INSIGHTS_TAB[0] && (
                // {currentTab === POSITION_INSIGHTS_TAB[1] && (
                <PositionStatusPositionInsights
                  activeKey={activeKey}
                  setActiveKey={setActiveKey}
                  totalPositionStatus={totalPositionStatus}
                  setLoading={setLoading}
                  setStackChartData={setStackChartData}
                  handleOnClickReport={handleOnClickReport}
                />
              )}
              {/* {currentTab === POSITION_INSIGHTS_TAB[0] && <SPWithoutSuccessor />} */}
            </div>
          </Spin>
        </div>
      ) : (
        //need to update report when update order of tab in ViewReportPositionInsights.js
        <ViewReportPositionInsights
          reportType={currentTab}
          filterMasterData={{}}
          totalPosition={getTotalPosition}
          //need to update the stacked bar chart when update order of tab in PositionStatusPositionInsightsChart.js, BarChartCard.js
          stackChartData={stackChartData[currentTab]}
          tabFilters={{
            [POSITION_INSIGHTS_TAB[0]]: activeKey,
            [POSITION_INSIGHTS_TAB[1]]: yopFilter,
            // [POSITION_INSIGHTS_TAB[1]]: activeKey,
            // [POSITION_INSIGHTS_TAB[2]]: yopFilter,
          }}
          setStackChartData={setStackChartData}
          showSensitiveOnly={showSensitiveOnly}
        />
      )}
    </>
  );
};

PositionInsights.propTypes = {};

export default PositionInsights;
